export default "__VITE_PUBLIC_ASSET__19d97966__"